import { useI18n } from 'vue-i18n';
import * as yup from 'yup';
import { type Shape, type Device as VolanteDevice } from '@centric-os/types';

export default (siteNames: string[]) => {
  const { t } = useI18n();

  const schema = yup.object<Shape<VolanteDevice>>({
    business_units: yup
      .array()
      .of(yup.string())
      .min(
        1,
        t('errorMessages.minValue', {
          minValue: '1',
          record: 'business unit',
        }),
      )
      .required(t('errorMessages.required')),
    site_device_id: yup.string().required(t('errorMessages.required')),
    vendor: yup.string().required(t('errorMessages.required')),
    device_type: yup.string().required(t('errorMessages.required')),
    name: yup
      .string()
      .required(t('errorMessages.required'))
      .test({
        name: 'unique-name',
        test(value, ctx) {
          const sameName = siteNames.includes(value);
          return sameName
            ? ctx.createError({
                message: t('sites.stationIntegrations.device.quickMenu.sameNameError'),
              })
            : true;
        },
      }),
  });

  return {
    schema,
  };
};
